import React, { useEffect, useRef, useState } from "react";
import ReactTooltip from "react-tooltip";
import moment from "moment-timezone";
import { DateRangePicker } from "react-dates";

import { Row } from "../../components/Layout";
import NTMButton from "../../components/Buttons/NTMButton";
import NTMSelect from "components/Buttons/NTMSelect";
import Charts from "containers/Data/ChartsV2";

import { useGetDevices, getStatisticalData } from "../../service/Agrismart2Service";
import styles from "./_agrismart.module.scss";


export default function AveragePageV2({ type = 'stats' }) {

	let { devices } = useGetDevices()
	let [device, setDevice] = useState();
	let [startDate, setStartDate] = useState();
	let [endDate, setEndDate] = useState();
	let [focusedInput, setFocusedInput] = useState();
	let [data, setData] = useState([])
	let buttonRef = useRef();

	useEffect(() => {
		if (!device && devices?.length > 0) {
			setDevice(devices[0].device)
		}
		else if (startDate && endDate) {
			let start = moment(startDate).format("YYYY-MM-DD");
			let end = moment(endDate).format("YYYY-MM-DD");
			getStatisticalData(device, start, end, type).then(a => {
				let newData = []
				a.forEach(b => {
					switch (b.type) {
						case 2: // avg
							// riscrive paramMap escludento i parametri per cui non interessa il valor medio
							b.paramMap = Object.fromEntries(
								Object.entries(b.paramMap).filter(([key]) => !(key.startsWith('radiation') || key.startsWith('rainfall')))
							)
							newData.push(b)
							break;
						case 3:	// min
						case 4:	// max
							break;
						case 5: // sum
							// riscrive paramMap con i parametri per cui interessa il cumulativo, non il valor medio
							b.paramMap = Object.fromEntries(
								Object.entries(b.paramMap).filter(([key]) => key.startsWith('radiation') || key.startsWith('rainfall'))
							)
							newData.push(b)
							break;
						default:
							break;
					}
				});
				setData(newData)
			})
		}
	}, [device, devices, startDate, endDate, type])

	if (devices.length === 0) return null

	let deviceObj = devices.find(d => d.device === device);

	return <div className="animated fadeIn">
		<Row className={styles.box}>
			<NTMSelect value={device} onChange={event => setDevice(event.target.value)}>
				{devices.map(d =>
					<option key={d.device} value={d.device}>{d.label || d.device}</option>
				)
				}
			</NTMSelect>
			<div data-tip data-for='global' data-event='click' ref={buttonRef}>
				<NTMButton primary>
					{
						startDate ?
							`${moment(startDate).format("DD/MM/YYYY")} - ${moment(endDate).format("DD/MM/YYYY")}`
							:
							<>Scegli Periodo&nbsp;<i className="fa fa-caret-down" aria-hidden="true" /></>
					}
				</NTMButton>
			</div>
			<ReactTooltip
				id='global'
				aria-haspopup='true'
				effect='solid'
				place={"bottom"}
				clickable
				getContent={() => <DateRangePicker
					startDate={startDate} // momentPropTypes.momentObj or null,
					startDateId="your_unique_start_date_id" // PropTypes.string.isRequired,
					endDate={endDate} // momentPropTypes.momentObj or null,
					endDateId="your_unique_end_date_id" // PropTypes.string.isRequired,
					onDatesChange={({ startDate, endDate }) => {
						setStartDate(startDate)
						setEndDate(endDate)
						if (startDate && endDate) {
							buttonRef.current.click();
						}
					}} // PropTypes.func.isRequired,
					focusedInput={focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
					onFocusChange={focusedInput => setFocusedInput(focusedInput)} // PropTypes.func.isRequired,
					withPortal={true}
					startDatePlaceholderText={"Inizio"}
					endDatePlaceholderText={"Fine"}
					displayFormat={"DD/MM/YYYY"}
					isOutsideRange={(o) => o.isAfter(moment(), 'day')}
					small={true}
				/>}
			/>
		</Row>
		<div style={{ margin: "1rem auto" }}>
			<Charts data={data} device={deviceObj} type={type || 'statistics'} />
		</div>
	</div>
}
